module.exports = __webpack_public_path__ + "img/mx.8402ad79.svg";